import { createClient } from 'contentful';

const space = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const environment = process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master';
const accessToken = process.env.REACT_APP_CONTENTFUL_DELIVERY_TOKEN;

if (!space || !accessToken) {
  throw new Error(
    'Missing Contentful env vars. Expected REACT_APP_CONTENTFUL_SPACE_ID and REACT_APP_CONTENTFUL_DELIVERY_TOKEN.'
  );
}

export const contentfulClient = createClient({ space, environment, accessToken });